import ReactECharts from 'echarts-for-react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';

export default function WeatherDayGraph(props) {
  const weather = props.weather;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
            <Tab label="Temperatura" {...a11yProps(0)} />
            <Tab label="Precipitazioni" {...a11yProps(1)} />
            
          </Tabs>
        </Box>
        <TabPanel value={value} index={1}>
          <RainGraph weather={weather} />
        </TabPanel>
        <TabPanel value={value} index={0}>
          <TempGraph weather={weather} />
        </TabPanel>
        
      </Box>
    </div>
  )
}



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component='div'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function RainGraph(props) {
  const theme = useTheme().palette.mode
  const weather = props.weather;
  const option = {
    title: {
      text: 'Precipitazioni'
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: weather.map(w => getHour(w.dt))
    },
    legend: {
      data: ['Rain']
    },
    tooltip: {
      trigger: 'axis'
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: weather.map(w => w.pop*100),
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 3,
          shadowColor: 'rgba(0,0,0,0.3)',
          shadowBlur: 10,
          shadowOffsetY: 8
        },
      }
    ]
  };

  return (
    <>
      <ReactECharts
        option={option}
        theme={theme}
      />
    </>
  )
}

function TempGraph(props) {
  const theme = useTheme().palette.mode
  const weather = props.weather;
  const option = {
    title: {
      text: 'Temperatura'
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: weather.map(w => getHour(w.dt))
    },
    grid: { 
      containLabel: true
    },
    legend: {
      data: ['Temperatura', 'Percepita']
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    tooltip: {
      trigger: 'axis',
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: weather.map(w => w.temp),
        type: 'line',
        name:'Temperatura',
        smooth: true,
        stack: 'Total',
        lineStyle: {
          width: 3,
          shadowColor: 'rgba(0,0,0,0.3)',
          shadowBlur: 10,
          shadowOffsetY: 8,
          color: 'rgb(255,165,0)',
        },
        itemStyle: {
          color: 'rgb(255,165,0)'
        }
      },
      {
        data: weather.map(w => w.feels_like),
        type: 'line',
        name:'Percepita',
        smooth: true,
        lineStyle: {
          width: 3,
          shadowColor: 'rgba(0,0,0,0.3)',
          shadowBlur: 10,
          shadowOffsetY: 8,
          color: 'rgb(255,0,0)',
        },
        itemStyle: {
          color: 'rgb(255,0,0)'
        }
      }
    ]
  };

  return (
    <>
      <ReactECharts
        option={option}
        theme={theme}
      />
    </>
  )
}

function getHour(utc) {
  let d = new Date(utc * 1000)
  return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
}